/**
 * The `/resource/*` routes reservations v2 calls (RESERVATIONS_V2_PLAN.md §4.6, RV1c), held to the
 * backend snapshot by `api/routes.test.ts`. The wire type is the backend's shape as read from its
 * code, so `api/` imports nothing from `tables/`.
 */
import { anySession } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

/**
 * A table of a branch ("resource" to the backend), as `resource/branch/fetchAll` answers it: active
 * tables only, audit fields removed, `_id` as `mid` (resource_controller.js:64-80,
 * business_common_service.js:54-68).
 */
export interface WireTable {
  /** the table's id */
  mid: string;
  /** the table's name, such as "T4" */
  name: string;
  /** how many guests the table seats */
  capacity?: number;
  /** the id of the section (table group) the table sits in */
  resourceGroupId?: string;
  /** `Active` for every table this route returns */
  status?: string;
  /** the branch the table belongs to */
  branchId?: string;
  /** the kind of bookable thing: a table, or a person in appointment mode */
  resourceType?: string;
  /** any other table field the backend stores */
  [field: string]: unknown;
}

/** The `/resource/*` route v2 calls: the branch's list of tables. */
export const RESOURCE = defineRoutes("resource", {
  /** the branch's active tables */
  branchFetchAll: route<undefined, WireTable[]>("GET", "/resource/branch/fetchAll", anySession(), {
    notes:
      "the branch's active tables; query `branchId`, else the token's. The backend registers it with `module:` (a typo) instead of `modules:`, so any signed-in session may call it (backend.md §6.1; resource_controller.js:21)",
  }),
});
